import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  Form,
  FormSection,
} from 'uikit/layout'
import { Field, Formik } from 'formik'
import { HStack, Text } from '@chakra-ui/react'
import { Tooltip, Button } from 'uikit'
import { useFetchSettings } from './services/useFetchSettings'
import { useUpdateSettings } from './services/useUpdateSettings'
import { SwitchForm } from 'uikit/FormStateComponents/SwitchForm'
import { MdInfoOutline } from 'react-icons/md'

export const DeactivationModules = () => {
  const { data, isPending: isLoadingFetchSettings } = useFetchSettings()
  const dataSettings = data ? data[0] : {}
  const { mutate: updateSettings, isPending: isLoadingUpdate } = useUpdateSettings()

  const isLoading = isLoadingFetchSettings || isLoadingUpdate

  const handleForm = (values) => {
    const payload = {
      referralHidden: values?.referralHidden ? 1 : 0,
    }
    updateSettings(payload)
  }

  return (
    <Container>
      <CardContainer indentTop={120} isHideBack>
        <ContentContainer>
          <ContentContainerColumn>
            <Formik
              initialValues={{
                referralHidden: dataSettings?.referralHidden === 1,
              }}
              enableReinitialize
              onSubmit={handleForm}
            >
              {(props) => (
                <Form
                  onSubmit={props.handleSubmit}
                  footer={
                    <Button type="submit" colorPalette="orange" loading={isLoading}>
                      Обновить
                    </Button>
                  }
                >
                  <FormSection>
                    <Field
                      size="lg"
                      name="referralHidden"
                      component={SwitchForm}
                      label={
                        <HStack>
                          <Text>Скрыть модуль реферальной системы</Text>
                          <Tooltip content="Включенное (активное) положение бегунка означает отключение модуля в мобильном приложении">
                            <MdInfoOutline cursor="pointer" color="blue.500" />
                          </Tooltip>
                        </HStack>
                      }
                      disabled={isLoading}
                    />
                  </FormSection>
                </Form>
              )}
            </Formik>
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>
    </Container>
  )
}
